import React, { useState, useEffect, useMemo } from 'react';
import {
  Button,
  Input,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Card,
  CardBody
} from 'reactstrap';

const defaultNotes = [
  {
    id: 1,
    category: "ZORUNLU AÇIKLAMALAR",
    notes: [
      "Servis esnasında arızalı oldugu tespit edilen cihazların tamiri veya periyodik değişecek malzemeler (teklif harici) yenisi ile değiştirilmesi servis ücretine dahil değildir. Ayrıca Faturalandırılır.",
      "Değiştirilmesi veya mümkünse tamiri yapılacak cihazların bedeli tarafınıza bildirilecek, onayınız alındıktan sonra tamir gerçekleştirilecek veya yeni cihaz temin edilecektir.",
      "Bakım Harici servis istenmesi durumunda ADAM X GÜN 350 USD + KDV Faturalandırılır.",
      "Servis esnasında yüksekte çalışma için ihtiyaç duyulan men-lift, forklift, ahtapot vb. iş makinaları işveren tarafından temin edilecektir.",
      "Her türlü inşai işleri (duvar kırma, duvar örme, karot delme, kazı, kapatma, boru köprüsü v.b.) teklifimize dahil değildir.",
      "Kargo ve taşımacılık masrafları firmanıza aittir."
    ]
  },
  {
    id: 2,
    category: "FİYATLANDIRMA VE ÖDEME KOŞULLARI",
    notes: [
      "Fiyatlarımıza KDV dahil değildir. KDV ayrıca uygulanır.",
      "Fiyatlarımızın TL bedeli ödeme günündeki T.C.M.B. Döviz satış kuru ile çarpılarak hesaplanır.",
      "Vadesi geçen ödemeler için aylık %5 vade farkı faturası kesilecektir.",
      "Fiyatlandırmalar proje bazlı özel indirimler ile verilmiş olup, teklif içerisinden adet fiyat ürün istenmesi durumunda fiyat değişkenlik gösterir."
    ]
  },
  {
    id: 3,
    category: "SİPARİŞ VE İADE KOŞULLARI",
    notes: [
      "Teklifimizin siparişe dönmesi durumunda; teklif içeriğine onay vermeden önce, teklifte bulunan tüm ürünlerin talebinize uygun olmadığını lütfen tekrar kontrol ediniz.",
      "Aksi takdirde ürünlerin talepten ve ihtiyaçtan farklı olması, fazla olması ve/veya kullanılmamış olması vb. nedenlerden dolayı ürünlerin iadesinin kabul edilemeyeceğini önemle dikkatinize ve bilgilerinize sunarız.",
      "Özel imalat ile sipariş verilen ürünlerde iade veya değişim yapılmamaktadır."
    ]
  },
  {
    id: 4,
    category: "PROJE VE TEKNİK HİZMETLER",
    notes: [
      "Yangın Söndürme Sistem çizimleri (plan, kesit izometrik görünüş)",
      "Hidrolik Hesapların Yapılması (OmniCADD)",
      "Acil Aydınlatma Yönlendirme sistem cizimleri (plan kesit)",
      "Türkçe formatında projelerin teslimi (çıktı usb CD vs)",
      "Teknik şartnamelerin Düzenlenmesi",
      "Projelendirme Elektrik mühendisleri ve Makine Mühendisleri Odalarının Fiyatlarına Tabidir.",
      "Kauson Efekt tablosunun Hazırlanması"
    ]
  },
  {
    id: 5,
    category: "BAKIM VE SERVİS KOŞULLARI",
    notes: [
      "Periyodik bakım hizmeti teklifimize dahil değildir.",
      "Teklife Demontaj-Montaj, test, servis ve devreye alma bedeli teklife dahil değildir.",
      "Sistemin kurulumu ve devreye alınması esnasında gerekli olan elektrik temini teklifimize dahil değildir.",
      "Proje başlangıcında işveren ile iş programı ve haftalık iş programları bildirilecektir.",
      "Mahalde çalışma yapılırken pompaların demontaj ve montaj işlemleri için, kurulması gerekebilecek elektrikli ve raylı vinç sistemi gerekmesi durumunda işletme yönetimi tarafından temin edilecektir.",
      "Sahada Yapılan bütün bakım çalışmalarında aşağıda belirtilen raporlar tarafınıza ayrıca sunulacaktır.",
      "Vana bakımı (Vana İç Takımı) dahil değildir. Dolum esnasında arızalı olduğu anlaşılan vanalar kurumun onayına istinaden ücreti mukabilinde değiştirilir.",
      "Bakımlar esnasında değişimi yapılacak malzemeler teklifte belirtilmiştir. Yılda bir teklif dahilinde değişimleri yapılacaktır."
    ]
  }
];



const GetAndSelectNotes = ({ onNotesSelect, initialNotes = [] }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedNotes, setSelectedNotes] = useState(initialNotes);

  useEffect(() => {
    if (initialNotes && initialNotes.length > 0) {
      setSelectedNotes(initialNotes);
    }
  }, [initialNotes]);

  const toggleModal = () => setModalOpen(!modalOpen);

  const handleNotesSelect = (notes) => {
    setSelectedNotes(notes);
    onNotesSelect(notes);
  };

  const groupedNotes = useMemo(() => {
    return selectedNotes.reduce((acc, note) => {
      if (!acc[note.category]) {
        acc[note.category] = [];
      }
      acc[note.category].push(note);
      return acc;
    }, {});
  }, [selectedNotes]);

  return (
    <>
      <CardBody className="p-4 border-top border-top-dashed">
        <div className="mb-3">
          <div className="d-flex align-items-center justify-content-between">
            <h5 className="mb-0">Teklif Notları</h5>
            <Button
              color="primary"
              onClick={toggleModal}
              size="sm"
            >
              <i className="ri-add-line align-middle me-1"></i>
              Notları Düzenle
            </Button>
          </div>
        </div>

        <div className="selected-notes">
          {Object.entries(groupedNotes).length > 0 ? (
            Object.entries(groupedNotes).map(([category, notes]) => (
              <div key={category} className="mb-4">
                <h6 className="mb-3 fw-semibold text-uppercase">{category}</h6>
                <ListGroup>
                  {notes.map((note) => (
                    <ListGroupItem
                      key={note.key}
                      className="px-0 border-0"
                    >
                      <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                          <i className="ri-checkbox-circle-fill text-success"></i>
                        </div>
                        <div className="flex-grow-1">
                          <p className="text-muted mb-0">{note.text}</p>
                        </div>
                      </div>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </div>
            ))
          ) : (
            <div className="text-center text-muted p-4 border rounded">
              <p className="mb-0">Henüz not seçilmedi</p>
              <p className="mb-0 small">Notları düzenlemek için "Notları Düzenle" butonuna tıklayın</p>
            </div>
          )}
        </div>
      </CardBody>

      <NoteSelector
        isOpen={modalOpen}
        toggle={toggleModal}
        onNotesSelect={handleNotesSelect}
        initialNotes={selectedNotes}
      />
    </>
  );
};

// Modal component for selecting notes
const NoteSelector = ({ isOpen, toggle, onNotesSelect, initialNotes = [] }) => {
  const [selectedNotes, setSelectedNotes] = useState(initialNotes);
  const [activeTab, setActiveTab] = useState('default'); // 'default' veya 'manual'
  const [manualCategories, setManualCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    name: '',
    notes: ['']
  });

  const handleAddNoteToCategory = () => {
    setNewCategory(prev => ({
      ...prev,
      notes: [...prev.notes, '']
    }));
  };

  const handleRemoveNoteFromCategory = (index) => {
    setNewCategory(prev => ({
      ...prev,
      notes: prev.notes.filter((_, i) => i !== index)
    }));
  };

  const handleCategoryNoteChange = (index, value) => {
    setNewCategory(prev => ({
      ...prev,
      notes: prev.notes.map((note, i) => i === index ? value : note)
    }));
  };

  const handleSaveCategory = () => {
    if (newCategory.name.trim() && newCategory.notes.some(note => note.trim())) {
      const filteredNotes = newCategory.notes.filter(note => note.trim());
      const newManualCategory = {
        id: `manual-${Date.now()}`,
        category: newCategory.name.toUpperCase(),
        notes: filteredNotes
      };

      setManualCategories(prev => [...prev, newManualCategory]);
      setNewCategory({ name: '', notes: [''] });
    }
  };

  const handleNoteToggle = (categoryId, noteIndex) => {
    const noteKey = `${categoryId}-${noteIndex}`;
    const note = defaultNotes.find(cat => cat.id === categoryId)?.notes[noteIndex];

    if (selectedNotes.some(n => n.key === noteKey)) {
      setSelectedNotes(selectedNotes.filter(n => n.key !== noteKey));
    } else {
      setSelectedNotes([...selectedNotes, {
        key: noteKey,
        text: note,
        category: defaultNotes.find(cat => cat.id === categoryId).category
      }]);
    }
  };

  const handleCustomNoteAdd = () => {
    if (customNote.trim()) {
      const newNote = {
        key: `custom-${Date.now()}`,
        text: customNote,
        category: customNoteCategory,
        isCustom: true
      };
      setSelectedNotes([...selectedNotes, newNote]);
      setCustomNote('');
      setShowCustomNote(false);
    }
  };

  const removeNote = (noteKey) => {
    setSelectedNotes(selectedNotes.filter(note => note.key !== noteKey));
  };

  const handleSave = () => {
    onNotesSelect(selectedNotes);
    toggle();
  };

  // Group selected notes by category
  const groupedSelectedNotes = useMemo(() => {
    return selectedNotes.reduce((acc, note) => {
      if (!acc[note.category]) {
        acc[note.category] = [];
      }
      acc[note.category].push(note);
      return acc;
    }, {});
  }, [selectedNotes]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Teklif Notları</ModalHeader>
      <ModalBody>
        <div className="mb-4">
          <div className="btn-group w-100">
            <Button
              color={activeTab === 'default' ? 'primary' : 'light'}
              onClick={() => setActiveTab('default')}
              className="w-50"
            >
              <i className="ri-file-list-line me-1"></i>
              Varsayılan Notlar
            </Button>
            <Button
              color={activeTab === 'manual' ? 'primary' : 'light'}
              onClick={() => setActiveTab('manual')}
              className="w-50"
            >
              <i className="ri-edit-box-line me-1"></i>
              Manuel Giriş
            </Button>
          </div>
        </div>

        <Row>
          <Col md={12} className="mb-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Seçilen Notlar</h5>
              {activeTab === 'default' && (
                <Button
                  color="primary"
                  size="sm"
                  onClick={() => setShowCustomNote(!showCustomNote)}
                >
                  <i className="ri-add-line align-middle me-1"></i>
                  Özel Not Ekle
                </Button>
              )}
            </div>

            {/* Seçili Notların Gösterimi */}
            {Object.entries(groupedSelectedNotes).length > 0 ? (
              Object.entries(groupedSelectedNotes).map(([category, notes]) => (
                <div key={category} className="mb-3">
                  <h6 className="text-muted border-bottom pb-2">{category}</h6>
                  <ListGroup>
                    {notes.map((note) => (
                      <ListGroupItem
                        key={note.key}
                        className="d-flex justify-content-between align-items-center p-2"
                      >
                        <span className="small">{note.text}</span>
                        <Button
                          color="link"
                          className="text-danger p-0 ms-2"
                          onClick={() => removeNote(note.key)}
                        >
                          <i className="ri-delete-bin-line"></i>
                        </Button>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
              ))
            ) : (
              <div className="text-center text-muted p-3 border rounded">
                Henüz not seçilmedi
              </div>
            )}
          </Col>

          {activeTab === 'default' ? (
            /* Varsayılan Notlar Bölümü */
            <Col md={12}>
              <h5 className="mb-3">Varsayılan Notlar</h5>
              {defaultNotes.map((category) => (
                <div key={category.id} className="mb-4">
                  <h6 className="text-muted border-bottom pb-2">{category.category}</h6>
                  <ListGroup>
                    {category.notes.map((note, index) => (
                      <ListGroupItem
                        key={index}
                        className="d-flex align-items-center p-2 cursor-pointer"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleNoteToggle(category.id, index)}
                      >
                        <Input
                          type="checkbox"
                          className="me-2"
                          checked={selectedNotes.some(n => n.key === `${category.id}-${index}`)}
                          onChange={() => { }}
                        />
                        <span className="small">{note}</span>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
              ))}
            </Col>
          ) : (
            /* Manuel Giriş Bölümü */
            <Col md={12}>
              <Card className="mb-4">
                <CardBody>
                  <h5 className="mb-3">Yeni Kategori Oluştur</h5>
                  <div className="mb-3">
                    <Input
                      type="text"
                      placeholder="Kategori Adı"
                      value={newCategory.name}
                      onChange={(e) => setNewCategory(prev => ({ ...prev, name: e.target.value }))}
                    />
                  </div>

                  {newCategory.notes.map((note, index) => (
                    <div key={index} className="d-flex gap-2 mb-2">
                      <Input
                        type="textarea"
                        rows="2"
                        placeholder={`${index + 1}. Not`}
                        value={note}
                        onChange={(e) => handleCategoryNoteChange(index, e.target.value)}
                      />
                      {newCategory.notes.length > 1 && (
                        <Button
                          color="danger"
                          className="btn-icon"
                          onClick={() => handleRemoveNoteFromCategory(index)}
                        >
                          <i className="ri-delete-bin-line"></i>
                        </Button>
                      )}
                    </div>
                  ))}

                  <div className="d-flex gap-2 mt-3">
                    <Button
                      color="info"
                      outline
                      onClick={handleAddNoteToCategory}
                    >
                      <i className="ri-add-line align-middle me-1"></i>
                      Not Ekle
                    </Button>
                    <Button
                      color="success"
                      onClick={handleSaveCategory}
                      disabled={!newCategory.name.trim() || !newCategory.notes.some(note => note.trim())}
                    >
                      <i className="ri-save-line align-middle me-1"></i>
                      Kategoriyi Kaydet
                    </Button>
                  </div>
                </CardBody>
              </Card>

              {/* Manuel Oluşturulan Kategoriler */}
              {manualCategories.map((category) => (
                <div key={category.id} className="mb-4">
                  <h6 className="text-muted border-bottom pb-2 d-flex justify-content-between align-items-center">
                    {category.category}
                    <Button
                      color="link"
                      className="text-danger p-0"
                      onClick={() => setManualCategories(prev =>
                        prev.filter(cat => cat.id !== category.id)
                      )}
                    >
                      <i className="ri-delete-bin-line"></i>
                    </Button>
                  </h6>
                  <ListGroup>
                    {category.notes.map((note, index) => (
                      <ListGroupItem
                        key={index}
                        className="d-flex justify-content-between align-items-center p-2"
                      >
                        <span className="small">{note}</span>
                        <Button
                          color="link"
                          className="text-danger p-0"
                          onClick={() => {
                            const updatedCategory = {
                              ...category,
                              notes: category.notes.filter((_, i) => i !== index)
                            };
                            setManualCategories(prev =>
                              prev.map(cat => cat.id === category.id ? updatedCategory : cat)
                            );
                          }}
                        >
                          <i className="ri-delete-bin-line"></i>
                        </Button>
                      </ListGroupItem>
                    ))}
                  </ListGroup>
                </div>
              ))}
            </Col>
          )}
        </Row>

        <div className="text-end mt-4">
          <Button color="light" className="me-2" onClick={toggle}>
            İptal
          </Button>
          <Button color="primary" onClick={handleSave}>
            Kaydet
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default GetAndSelectNotes;